(function () {
  'use strict';

  if (window.vmInstaFeedLoaded) return;
  window.vmInstaFeedLoaded = true;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Feed type from referrer + URL params (null when none applies).
  function getFeedOverride(root) {
    var type = null;

    var urlParams = new URLSearchParams(window.location.search);
    if((document.referrer.indexOf("advanced") >= 0 && document.referrer.indexOf("grip") >= 0 && document.referrer.indexOf("football") >= 0) || urlParams.get('type_advanced') == 'football') {
      type = 'T_Glove_football_System';
      root.classList.add('football_page_product_ags');
    } else if (document.referrer.indexOf("football") >= 0 || urlParams.get('type') == 'football') {
      type = 'T_Football';
    } else if(document.referrer.indexOf("golf") >= 0 || urlParams.get('type') == 'golf') {
      type = 'T_Golf';
    } else if((document.referrer.indexOf("grip") >= 0) || urlParams.get('type_advanced') == 'shoes') {
      type = 'T_Shoe_system';
    }

    return type;
  }

  function getFeedType(root) {
    return getFeedOverride(root) || root.getAttribute('data-feed_type');
  }

  // Server-rendered JSON from section blocks (replaces window[type] metafields).
  function getFeedJson(type) {
    var el = document.querySelector('[data-vm-insta-json][data-feed_type="' + type + '"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Feeds that show only on a URL/referrer match (placed above reviews in product.json, so never the default).
  var URL_ONLY_TYPES = ['T_Football', 'T_Glove_football_System', 'T_Golf'];

  // PDP: sections are pre-filtered by product list in Liquid; among those, the URL/referrer type wins, else the first non-URL-only one.
  function isActivePdpSection(root) {
    if (!root.hasAttribute('data-pdp')) return true;
    var pdpRoots = Array.prototype.filter.call(
      document.querySelectorAll('[data-vm-insta-feed][data-pdp]'),
      function (r) { return URL_ONLY_TYPES.indexOf(r.getAttribute('data-feed_type')) < 0; }
    );
    var type = getFeedOverride(root);
    // A match with no videos shows nothing (no fallback to a default feed).
    if (type && document.querySelector('[data-vm-insta-feed][data-pdp][data-feed_type="' + type + '"]')) {
      return root.getAttribute('data-feed_type') === type && !root.hasAttribute('data-empty');
    }
    return root === pdpRoots[0] && !root.hasAttribute('data-empty');

    // Fallback to the default feed when the matched feed has no videos (disabled).
    // To enable, replace the lines above (from "var type") with:
    // var type = getFeedOverride(root);
    // if (type && document.querySelector('[data-vm-insta-feed][data-pdp][data-feed_type="' + type + '"]:not([data-empty])')) {
    //   return root.getAttribute('data-feed_type') === type;
    // }
    // return root === document.querySelector('[data-vm-insta-feed][data-pdp]:not([data-empty])');
  }

  function initVmInstaFeed(root) {
    var type = getFeedType(root);
    var track = root.querySelector('[data-vm-insta-track]');
    var loading = root.querySelector('[data-vm-insta-loading]');
    var template = root.querySelector('[data-vm-insta-card-template]');
    var prevBtn = root.querySelector('[data-vm-insta-prev]');
    var nextBtn = root.querySelector('[data-vm-insta-next]');

    if (root.hasAttribute('data-pdp')) type = root.getAttribute('data-feed_type');

    var data_json = getFeedJson(type) || getFeedJson(root.getAttribute('data-feed_type'));

    if (!data_json || !data_json.data || !data_json.data.length) {
      if (loading) loading.remove();
      return;
    }

    // Autoplay: muted videos play while at least 60% visible, pause when scrolled away.
    var autoplayObserver = null;
    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      autoplayObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            var video = card.querySelector('[data-vm-insta-video]');
            if (!video) return;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              if (!card._vmUserPaused) safePlay(card, video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.6] }
      );
    }

    // Lazy-load: set video src only when the card enters the visible slider area.
    function loadVideo(card) {
      loadImages(card);
      var v = card.querySelector('[data-vm-insta-video]');
      if (v && card._vmSrc && !v.getAttribute('src')) v.src = card._vmSrc;
    }

    function loadImages(card) {
      if (!card._vmImg) return;
      var thumb = card.querySelector('[data-vm-insta-thumb]');
      var v = card.querySelector('[data-vm-insta-video]');
      if (thumb && !thumb.getAttribute('src')) thumb.src = card._vmImg;
      if (v && !v.getAttribute('poster')) v.setAttribute('poster', card._vmImg);
    }

    var lazyObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (entry.target._vmSrc) loadVideo(entry.target);
                else loadImages(entry.target);
                lazyObserver.unobserve(entry.target);
              }
            });
          },
          { root: track, rootMargin: '0px 600px', threshold: 0.01 }
        )
      : null;

    function safePlay(card, video) {
      loadVideo(card);
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          // Autoplay blocked (e.g. iOS Low Power Mode) - leave the play button visible.
          card.classList.remove('is-playing');
        });
      }
    }

    function muteOthers(exceptVideo) {
      track.querySelectorAll('[data-vm-insta-video]').forEach(function (v) {
        if (v !== exceptVideo) {
          v.muted = true;
          var c = v.closest('.vm-insta-feed__card');
          if (c) c.classList.add('is-muted');
        }
      });
    }

    function formatFollowers(n) {
      // Text like "19.6k" is shown as typed.
      if (typeof n === 'string' && n.trim() !== '' && isNaN(Number(n))) return n.trim();
      n = Number(n) || 0;
      if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
      return String(n);
    }

    function buildCard(post, index) {
      var node = template.content.firstElementChild.cloneNode(true);
      var isVideo = post.type === 'video';
      node.setAttribute('data-type', isVideo ? 'video' : 'image');
      node.classList.add('is-muted');

      var link = node.querySelector('[data-vm-insta-link]');
      var thumb = node.querySelector('[data-vm-insta-thumb]');
      var video = node.querySelector('[data-vm-insta-video]');
      var playBtn = node.querySelector('[data-vm-insta-play]');
      var muteBtn = node.querySelector('[data-vm-insta-mute]');
      var avatar = node.querySelector('[data-vm-insta-avatar]');
      var username = node.querySelector('[data-vm-insta-username]');
      var followers = node.querySelector('[data-vm-insta-followers]');

      var imgUrl = post.images && post.images.standard_resolution && post.images.standard_resolution.url;
      var videoUrl = isVideo && post.videos && post.videos.standard_resolution && post.videos.standard_resolution.url;

      if (link) link.href = post.link || '#';
      if (imgUrl) {
        node._vmImg = imgUrl;
        if (index < 3) {
          if (thumb) {
            thumb.loading = 'eager';
            thumb.setAttribute('fetchpriority', 'high');
          }
          loadImages(node);
        } else if (!lazyObserver) {
          loadImages(node);
        }
      }

      if (isVideo && videoUrl) {
        // Browsers only allow autoplay when muted + inline (iOS).
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.loop = true;
        video.preload = 'none';

        // Video file loads only when the card is on screen in the slider.
        node._vmSrc = videoUrl;
        if (index < 2) {
          video.preload = 'metadata';
          video.src = videoUrl;
        }
        if (lazyObserver) lazyObserver.observe(node);
        else video.src = videoUrl;

        video.addEventListener('play', function () {
          node.classList.add('is-playing');
        });
        video.addEventListener('pause', function () {
          node.classList.remove('is-playing');
        });

        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          node._vmUserPaused = false;
          safePlay(node, video);
        });

        video.addEventListener('click', function (e) {
          e.preventDefault();
          if (!video.paused) {
            node._vmUserPaused = true; // don't auto-resume something the user paused
            video.pause();
          } else {
            node._vmUserPaused = false;
            safePlay(node, video);
          }
        });

        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          node.classList.toggle('is-muted', video.muted);
          if (!video.muted) {
            muteOthers(video); // only one card with sound at a time
            if (video.paused) safePlay(node, video);
          }
        });

        if (autoplayObserver) autoplayObserver.observe(node);
      } else {
        playBtn.style.display = 'none';
        if (muteBtn) muteBtn.style.display = 'none';
        video.remove();
        if (lazyObserver && node._vmImg) lazyObserver.observe(node);
      }

      var userObj = post.user || {};
      var displayName = userObj.username || userObj.full_name || '';
      var followerCount = userObj.followers;

      // Shown exactly as entered in the settings (include "@" there if wanted).
      if (username) username.textContent = displayName;
      if (followers) {
        followers.textContent =
          followerCount || followerCount === 0
            ? formatFollowers(followerCount) + ' followers'
            : '';
      }
      if (avatar && post.profile_picture) {
        avatar.style.backgroundImage = 'url(' + post.profile_picture + ')';
      }

      return node;
    }

    function render(json) {
      var posts = (json && json.data) || [];
      var meta = (json && json.meta) || {};

      if (autoplayObserver) autoplayObserver.disconnect();
      if (lazyObserver) lazyObserver.disconnect();
      track.querySelectorAll('video').forEach(function (v) { v.pause(); });
      track.innerHTML = '';

      posts.forEach(function (post, index) {
        if (!post.user) {
          post.user = {
            full_name: meta.full_name || meta.username,
            username: meta.username,
            followers: meta.followers
          };
        }
        if (!post.profile_picture && meta.profile_picture) {
          post.profile_picture = meta.profile_picture;
        }
        var card = buildCard(post, index);
        track.appendChild(card);
      });
    }

    if (data_json != '' && data_json != null) {
      if (loading) loading.remove();
      render(data_json);
    }

    function scrollByCard(direction) {
      var card = track.querySelector('.vm-insta-feed__card');
      var cardWidth = card ? card.getBoundingClientRect().width + 16 : 260;
      track.scrollBy({ left: direction * cardWidth * 2, behavior: 'smooth' });
    }

    function updateNavButtons() {
      if (!prevBtn && !nextBtn) return;

      var maxScrollLeft = track.scrollWidth - track.clientWidth;
      var scrollLeft = track.scrollLeft;
      var tolerance = 2;

      // Nothing to scroll: center the cards and hide the arrows.
      root.classList.toggle('is-static', maxScrollLeft <= tolerance);

      if (prevBtn) {
        prevBtn.disabled = scrollLeft <= tolerance;
      }
      if (nextBtn) {
        nextBtn.disabled = scrollLeft >= maxScrollLeft - tolerance;
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    track.addEventListener('scroll', updateNavButtons);
    window.addEventListener('resize', updateNavButtons);

    updateNavButtons();
  }

  function observeInstaFeeds() {
    var roots = document.querySelectorAll('[data-vm-insta-feed]');

    if (!('IntersectionObserver' in window)) {
      roots.forEach(function (root) {
        root.hidden = !isActivePdpSection(root);
        if (!root.hidden) initVmInstaFeed(root);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            initVmInstaFeed(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '100% 0px'
      }
    );

    roots.forEach(function (root) {
      root.hidden = !isActivePdpSection(root);
      if (!root.hidden) observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeInstaFeeds);
  } else {
    observeInstaFeeds();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-vm-insta-feed]');

    if (root) {
      root.hidden = !isActivePdpSection(root);
      if (root.hidden) return;
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries, observer) {
            if (entries[0].isIntersecting) {
              initVmInstaFeed(root);
              observer.unobserve(root);
            }
          },
          {
        rootMargin: '100% 0px'
          }
        );

        observer.observe(root);
      } else {
        initVmInstaFeed(root);
      }
    }
  });
})();